export const DANGER = "danger";
export const DEFAULT = "";
export const ALERT = "alert";
export const SUCCESS = "success";
export const RETAKE = "retake";
export const RENEWAL_CALCULATOR = "renewal_calculator";
export const COMPLETED_COURSES_FILTERS = "completed_courses_filters";
export const COURSE_LIST_FILTERS = "course_list_filters";
